import { render, staticRenderFns } from "./grid_item.vue?vue&type=template&id=b85198e2"
import script from "./grid_item.vue?vue&type=script&lang=js"
export * from "./grid_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports